export const pageOptionType = 'product-components.page-option';
export const miscOptionType = 'product-components.misc-option';
export const anyStringOptionType = 'product-components.any-string-option';
